import { __rest } from "tslib";
import React, { Fragment, useRef } from 'react';
import { NavigationItemType } from '../../../models';
import NavigationItem from '../NavigationItem/NavigationItem';
import NavigationPopup from '../NavigationPopup/NavigationPopup';
const NavigationDropdown = ({ className, data, isActive, hidePopup, onClick, }) => {
    const anchorRef = useRef(null);
    const { text, icon, items, iconSize } = data, popupProps = __rest(data, ["text", "icon", "items", "iconSize"]);
    return (React.createElement(Fragment, null,
        React.createElement(NavigationItem, { className: className, ref: anchorRef, onClick: onClick, isOpened: isActive, data: { text, type: NavigationItemType.Dropdown, icon, iconSize } }),
        React.createElement(NavigationPopup, Object.assign({ open: isActive, onClose: hidePopup, items: items, anchorRef: anchorRef }, popupProps))));
};
export default NavigationDropdown;
